<ng-template vdrDialogTitle>{{
  "qa.question" | translate
}}</ng-template>

<div *ngIf="question">
  <vdr-card>
    <div class="line-grid">
      <div class="line-grid" *ngIf="question.product; else orderQA">
        <div>{{ "order.product-name" | translate }} :</div>
        <div>
          <a
            class="button-ghost"
            target="_blank"
            [routerLink]="['/catalog/products', question.product.id]"
            >{{ question.product.name }} <clr-icon shape="arrow right"
          /></a>
        </div>
      </div>

      <ng-template #orderQA>
        <div class="line-grid" *ngIf="question.order">
          <div>{{ "common.order" | translate }} :</div>
          <div>
            <a
              class="button-ghost"
              target="_blank"
              [routerLink]="['/orders', question.orderId]"
              >{{ question.order.code }} <clr-icon shape="arrow right"
            /></a>
          </div>
        </div>
      </ng-template>

      <div class="line-grid">
        <div>{{ "customer.customer" | translate }} :</div>
        <div>
          <a
            class="button-ghost"
            target="_blank"
            [routerLink]="['/extensions/ui-customer', question.customer!.id]"
            >{{ question.customer!.firstName }} <clr-icon shape="arrow right"
          /></a>
        </div>
      </div>

      <div class="line-grid">
        <div>{{ "qa.secret" | translate }} :</div>
        <div>
          <clr-toggle-wrapper>
            <input
              type="checkbox"
              clrToggle
              name="enabled"
              [(ngModel)]="isPublic"
              (ngModelChange)="setSecret($event)"
            />
            <label>{{ isPublic ? "Show" : "Private" }}</label>
          </clr-toggle-wrapper>
        </div>
      </div>

      <div class="line-grid">
        <div>{{ "common.status" | translate }} :</div>
        <div>
          <vdr-chip
            [colorType]="
              question.status === 'WaitResponse' ? 'warning' : 'success'
            "
          >
            {{ question.status | formatStatus }}
          </vdr-chip>
        </div>
      </div>
    </div>
  </vdr-card>

  <vdr-card>
    <div style="display: flex">
      <label style="font-weight: bold; margin-right: 10px">{{ "common.created-at" | translate }}:
      </label>
      <div>
        {{ question.createdAt | localeDate }}
      </div>
    </div>

    <div style="display: flex">
      <label style="font-weight: bold; margin-right: 10px"
        >{{ "qa.question" | translate }}:
      </label>
      <div>
        {{ question.title }}
      </div>
    </div>

    <div
      *ngIf="assetChanges.assets && assetChanges.assets.length > 0"
      style="margin-top: 6px; margin-bottom: 6px"
    >
      <label>{{ "common.images" | translate }}:</label>
      <image-selector
        [assets]="assetChanges.assets"
        [featuredAsset]="assetChanges.featuredAsset"
      ></image-selector>
    </div>

    <div *ngIf="question.comments?.length > 0">
      <label style="margin-right: 10px; margin-top: 6px"
        >{{ "qa.comments" | translate }}:
      </label>

      <div style="height: 300px; overflow-y: auto; margin-top: 6px">
        <div>
          <div *ngFor="let cmt of comments; let i = index">
            <vdr-card [paddingX]="false" style="margin-bottom: 10px">
              <question-post-comment [message]="cmt"></question-post-comment>
            </vdr-card>
          </div>
        </div>
      </div>
    </div>

    <vdr-form-field
      [label]="'qa.answer' | translate"
      class="mt-1"
      *ngIf="question.status !== 'Resolved'"
    >
      <textarea
        autoResize
        [placeholder]="'qa.reply' | translate"
        [(ngModel)]="reply"
      ></textarea>
    </vdr-form-field>
  </vdr-card>
</div>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <ng-container *ngIf="question">
    <button type="button" class="button danger" (click)="delete()">
      {{ "qa.delete-question" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="comment()">
      {{ "qa.reply" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="changeStatus()">
      {{ changeStatusBtnText() | translate }}
    </button>
    <button type="button" class="button warning" (click)="pushWeChat()">
      推送微信
    </button>
  </ng-container>
</ng-template>